import React, { useEffect, useState } from 'react';
import {
  arrayOf, bool, func, oneOf, shape, string
} from 'prop-types';
import { useMetadata } from '@thd-nucleus/data-sources';
import { SuperSkuAttribute } from '../super-sku-attribute/super-sku-attribute';
import { SuperSkuAttributeValue } from '../super-sku-attribute-value/super-sku-attribute-value';

export const SuperDuperSku = (props) => {
  const {
    channel,
    handleSdskuAttributeValueClick,
    superDuperSku: {
      attributes
    } = {}
  } = props;

  const [parentId, setParentId] = useState(null);
  const [makeMetadataCall, superDuperSkuData] = useMetadata({ parentId, ssr: false, lazy: true });

  useEffect(() => {
    if (parentId) {
      makeMetadataCall();
    }
  }, [parentId]);

  useEffect(() => {
    if (!superDuperSkuData?.called) {
      return;
    }

    if (superDuperSkuData?.data) {
      const { metadata = {} } = superDuperSkuData.data;
      if (metadata.childItemsLookup) {
        handleSdskuAttributeValueClick(metadata);
      }
    }
  }, [superDuperSkuData?.data, superDuperSkuData]);

  const extractParentId = (superSkuUrl) => superSkuUrl?.split('/')?.pop();

  const { attributeName = '', attributeValues = [], isAvailable = true } = attributes[0];
  const selectedAttributeValue = attributeValues.find((attributeValue) => attributeValue.selected);
  const attributeType = 'tile';

  return (
    <div className="super-duper-sku">
      <SuperSkuAttribute
        attributeName={attributeName}
        attributeValue={selectedAttributeValue.value}
        attributeType={attributeType}
        key={attributeName}
      >
        {(attributeValues || []).map((attributeValue) => {
          const { value, superSkuUrl, selected } = attributeValue;

          return (
            <SuperSkuAttributeValue
              attributeType={attributeType}
              channel={channel}
              isAvailable={isAvailable}
              isSelected={selected}
              key={`${attributeName}-${value}`}
              onClick={() => setParentId(extractParentId(superSkuUrl))}
              value={value}
            />
          );
        })}
      </SuperSkuAttribute>
    </div>
  );
};

SuperDuperSku.displayName = 'SuperDuperSku';

SuperDuperSku.propTypes = {
  channel: oneOf(['desktop', 'mobile']),
  handleSdskuAttributeValueClick: func.isRequired,
  superDuperSku: shape({
    attributes: arrayOf(shape({
      attributeName: string,
      attributeValues: arrayOf(shape({
        selected: bool,
        superSkuUrl: string,
        value: string
      }))
    }))
  }).isRequired
};

SuperDuperSku.defaultProps = {
  channel: 'desktop'
};
